import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MarkdownLoaderService {
  private http = inject(HttpClient);

  getMarkdown(path: string | null) {
    if (!path) {
      return throwError(() => new Error('Conteúdo não encontrado'));
    }

    return this.http.get(`/public${path}`, { responseType: 'text' });
  }
}
